import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";


export const linksBeam = createBeam(bifrost, "/web/links");
